export const GUEST_USER_COOKIE = "SFE_GUEST_V2";
